// Shared side-navigation groups for the inner pages. Labels are i18n keys
// (resolved with $t in SideNav), reusing the `nav.*` messages used by the header.
export const markazNav = [
  { labelKey: 'nav.markazHaqida', to: '/markaz/markaz-haqida' },
  { labelKey: 'nav.rahbariyat', to: '/markaz/rahbariyat' },
  { labelKey: 'nav.boshqarmaBoshliqlari', to: '/markaz/boshqarma-boshliqlari' },
  { labelKey: 'nav.tuzilma', to: '/markaz/tuzilma' }
]

export const faoliyatNav = [
  { labelKey: 'nav.oquvMetodik', to: '/faoliyat/oquv-metodik' },
  { labelKey: 'nav.talimNormativlari', to: '/faoliyat/talim-normativlari' },
  { labelKey: 'nav.baholashMonitoring', to: '/faoliyat/baholash-monitoring' },
  { labelKey: 'nav.raqamliSavodxonlik', to: '/faoliyat/raqamli-savodxonlik' },
  // its own section (see ilmiyNav), listed here as in the header dropdown
  { labelKey: 'nav.ilmiyMetodik', to: '/ilmiy-metodik' },
  { labelKey: 'nav.hisobotlar', to: '/faoliyat/hisobotlar' }
]

export const hujjatlarNav = [
  { labelKey: 'nav.talimgaOidQonunlar', to: '/hujjatlar/talimga-oid' },
  { labelKey: 'nav.prezidentFarmonlari', to: '/hujjatlar/prezident-farmonlari' },
  { labelKey: 'nav.vazirlarMahkamasi', to: '/hujjatlar/vazirlar-mahkamasi' },
  { labelKey: 'nav.markazFaoliyati', to: '/hujjatlar/markaz-faoliyati' }
]

// Ilmiy-metodik faoliyat va xalqaro hamkorlik — opens as a flyout from the
// Faoliyat header dropdown, but is its own side-nav section. `soon` marks
// pages that are placeholders until their content arrives.
export const ilmiyNav = [
  { labelKey: 'nav.ilmiyMetodikFaoliyat', to: '/ilmiy-metodik/faoliyat', soon: true },
  { labelKey: 'nav.xalqaroHamkorlik', to: '/ilmiy-metodik/xalqaro-hamkorlik', soon: true },
  { labelKey: 'nav.yoshOlimlar', to: '/ilmiy-metodik/yosh-olimlar' },
  { labelKey: 'nav.ilmiyMaqolalar', to: '/ilmiy-metodik/ilmiy-maqolalar' },
  { labelKey: 'nav.ilmiyLoyihalar', to: '/ilmiy-metodik/ilmiy-loyihalar', soon: true }
]

export const axborotNav = [
  { labelKey: 'nav.savolJavob', to: '/axborot/savol-javob' },
  { labelKey: 'nav.ochiqMalumotlar', to: '/axborot/ochiq-malumotlar' },
  { labelKey: 'nav.yangiliklar', to: '/axborot/yangiliklar' },
  { labelKey: 'nav.galereya', to: '/axborot/galereya' }
]
